const reportWebVitals = onPerfEntry => {
  // Dynamic imports removed for build compatibility
};

export default reportWebVitals;